<template>

</template>

<script>
import Mutation from '@/library/Mutation';

export default {
  name: 'user-reset-email',
  data () {
    return {
      d_mutation: new Mutation(),
    };
  },
  created () {
    this.d_mutation.mutate(
      require('@/graphql/users/ChangeEmailConfirm.gql'),
      {
        emailChallenge: this.$route.query.email_challenge,
      }
    ).then(({ data }) => {
      const fullUrl = window.location;
      const appRootUrl = `${fullUrl.protocol}//${fullUrl.host}${process.env.BASE_URL}`;

      this.$oidc.signOut(
        {
          state: data[Object.keys(data)[0]].loginToken,
          post_logout_redirect_uri: `${appRootUrl}unauthCallback`,
        }
      );
    });
  },
}
</script>
